import DownloadOption from 'components/download-page/DownloadOption'
import DownloadPlatformButton from 'components/download-page/DownloadPlatformButton'
import { graphql, useStaticQuery } from 'gatsby'
import { Flex, Text } from 'theme-ui'
import getEnglishStrings from 'utils/getEnglishStrings'
import { platforms } from 'utils/platformList'

export default function PlatformDownloadSection({
  platformName,
  recommendedText,
}: {
  platformName: string
  recommendedText?: string
}): JSX.Element {
  const data = useStaticQuery<Queries.DesktopDownloadSectionQuery>(graphql`
    query DesktopDownloadSection {
      directus {
        general_translations {
          strings {
            languages_code {
              code
            }
            download
          }
        }
      }
    }
  `)

  const generalTranslationStrings = getEnglishStrings(data.directus.general_translations?.strings)

  return (
    <Flex sx={{ flexDirection: 'column', maxWidth: ['100%', '36rem'], gap: '2.4rem' }}>
      <Flex sx={{ flexDirection: 'column', gap: '0.8rem' }}>
        {platforms[platformName].downloadUrl && (
          <DownloadPlatformButton
            platformIcon={platforms[platformName].icon}
            downloadText={generalTranslationStrings?.download ?? ''}
            downloadUrl={platforms[platformName].downloadUrl}
            platformType="desktop"
          />
        )}
        {platforms[platformName].downloadUrl && recommendedText && (
          <Flex sx={{ width: '100%', justifyContent: 'center' }}>
            <Text sx={{ color: 'white50', fontSize: '1.2rem' }}>{recommendedText}</Text>
          </Flex>
        )}
      </Flex>
      <Flex sx={{ flexDirection: 'column', gap: '0.8rem', width: '100%' }}>
        {platforms[platformName]?.downloadOptions?.map(downloadOption => (
          <DownloadOption
            name={downloadOption.name}
            downloadUrl={downloadOption.downloadUrl}
            downloadTranslation={generalTranslationStrings?.download ?? ''}
            key={downloadOption.name}
          />
        ))}
      </Flex>
    </Flex>
  )
}
